//React
import React, { useId } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
//Assets
import infoIcon from "../../assets/svgs/info.svg";
//CSS
import "./inputs.scss";

/**
 * Info icon with a tooltip (ASB-3988). One component for the pairing that 13
 * files wired by hand: an `info.svg` with `data-tooltip-*` attributes plus a
 * react-tooltip `<Tooltip>` sharing an id. Keyboard-reachable (tab to it and
 * the tooltip shows) and announced via `label`.
 */
function InfoTip({ content, label, placement, size, className, id }) {
	const autoId = useId();
	const tipId = id ?? `infotip-${autoId}`;
	return (
		<>
			<span
				className={["as-infotip", `as-infotip--${size ?? "md"}`, className ?? ""].join(" ").trim()}
				data-tooltip-id={tipId}
				data-tooltip-content={content}
				tabIndex={0}
				role="img"
				aria-label={label ?? "More information"}
			>
				<img
					src={infoIcon}
					alt=""
					aria-hidden="true"
				/>
			</span>
			<Tooltip
				id={tipId}
				place={placement ?? "top"}
				className="as-infotip__tip"
			/>
		</>
	);
}

InfoTip.propTypes = {
	/** the tooltip text */
	content: PropTypes.string.isRequired,
	/** accessible name of the icon; default "More information" */
	label: PropTypes.string,
	placement: PropTypes.oneOf(["top", "right", "bottom", "left"]),
	size: PropTypes.oneOf(["sm", "md"]),
	className: PropTypes.string,
	/** override the generated tooltip id (only needed to share one Tooltip) */
	id: PropTypes.string,
};

export default InfoTip;
